export const GET_TYPES = "GET_TYPES"
export const CHANGE_POPUP = "CHANGE_POPUP"
export const ADD_TYPE = "ADD_TYPE"
export const EDIT_TYPE = "EDIT_TYPE"
export const DELETE_TYPE = "DELETE_TYPE"
export const CLOSE_ALERT = "CLOSE_ALERT"
